import { useState } from "react";

function Poster({ option }) {
  const [imgError, setImgError] = useState(false);

  return (
    <>
      {!imgError ? (
        <img
          src={option.poster_link}
          alt={option.name}
          className="h-[240px] md:h-[320px] object-cover object-center"
          onError={() => setImgError(true)}
        />
      ) : (
        <div
          className="h-[240px] md:h-[320px] flex items-center justify-center 
                     bg-white text-center text-slate-700 font-extrabold text-sm italic md:text-base p-2"
        >
          {option.show_name}
        </div>
      )}
    </>
  );
}

export default Poster;
